/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { PeriodTypeDto } from './periodTypeDto.schema';

export const IReadOnlyListOfPeriodTypeDto = zod.array(zod.lazy(() => PeriodTypeDto));

export type IReadOnlyListOfPeriodTypeDto = zod.input<typeof IReadOnlyListOfPeriodTypeDto>;
export type IReadOnlyListOfPeriodTypeDtoOutput = zod.output<typeof IReadOnlyListOfPeriodTypeDto>;
